import { render } from "./create-ticket.vue?vue&type=template&id=5254ff13&scoped=true"
import script from "./create-ticket.vue?vue&type=script&lang=js"
export * from "./create-ticket.vue?vue&type=script&lang=js"

import "./create-ticket.vue?vue&type=style&index=0&id=5254ff13&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5254ff13"]])

export default __exports__